const CONTACTUS_API =
  "https://shishuhriday.com/apis/ContactSubmissions.php";
  const LEADS_API = "https://shishuhriday.com/apis/leads.php";

const Login_api = "https://shishuhriday.com/apis/login.php";
const Signup_api = "https://shishuhriday.com/apis/signup.php";

const APPLY_JOB = "https://shishuhriday.com/apis/Careers.php";

const Fetch_all_data =
  "https://shishuhriday.com/apis/fetch_all_data.php";

const CRUD_Domains = "https://shishuhriday.com/apis/CRUD_Domains.php";

const CRUD_Price_table = "https://shishuhriday.com/apis/CRUD_Price_table.php";

const Payment_History = "https://shishuhriday.com/apis/payment_history.php";

const QUICK_PAY = "https://shishuhriday.com/apis/Payments/quickpay/create_order.php";
const QUICK_PAY_VERIFY="https://shishuhriday.com/apis/Payments/quickpay/verify_payment.php";

const DOMAIN_PAY="https://shishuhriday.com/apis/Payments/domainpay/create-order.php";
const DOMAIN_PAY_VERIFY="https://shishuhriday.com/apis/Payments/domainpay/verify_payment.php";

const GoogelAnalytics_API ="https://shishuhriday.com/apis/ga/dashboard.php";

export {
  CONTACTUS_API,LEADS_API,DOMAIN_PAY,DOMAIN_PAY_VERIFY,QUICK_PAY,QUICK_PAY_VERIFY,
  Login_api,GoogelAnalytics_API,
  Signup_api,
  APPLY_JOB,
  Fetch_all_data,
  Payment_History,
  CRUD_Domains,
  CRUD_Price_table,
};
